import React from 'react';
import { Skeleton } from '@scale/scaleui-radix';

const MenuLoadingSkeleton = () => {
  return (
    <div className="w-1/3 flex flex-col gap-4">
      <div>
        <Skeleton width="120px" height="20px" className="mb-3" />
        <div className="mb-3">
          <Skeleton width="140px" height="16px" className="mb-2" />
          <Skeleton width="100%" height="40px" />
        </div>

        {/* Options skeleton */}
        <div className="mt-4">
          <Skeleton width="160px" height="20px" className="mb-3" />
          <div className="space-y-3">
            <div>
              <Skeleton width="80px" height="16px" className="mb-2" />
              <Skeleton width="100%" height="40px" />
            </div>
            <div>
              <Skeleton width="100px" height="16px" className="mb-2" />
              <Skeleton width="100%" height="40px" />
            </div>
          </div>
        </div>

        {/* Order summary skeleton */}
        <div className="mt-4">
          <Skeleton width="100px" height="20px" className="mb-3" />
          <div className="space-y-2">
            <div className="flex justify-between">
              <Skeleton width="60px" height="16px" />
              <Skeleton width="80px" height="16px" />
            </div>
            <div className="flex justify-between">
              <Skeleton width="50px" height="16px" />
              <Skeleton width="70px" height="16px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuLoadingSkeleton;
